import { Console } from "console";
import { useAppSelector } from "../../../store/hooks";
import { isEqual } from "lodash";

export function pf(number: number) {
  var decimals = 2;
  var pow = Math.pow(10, decimals);
  return Number(Math.round(number * pow) / pow).toFixed(decimals);
}

// Same function in app/Webpage.php if changes then change in here too
export function getPageLocaleUrl(page: any, languages: any) {
  // @ts-ignore

  let locale = "et";
  let language = page.language;
  if (language && Array.isArray(languages)) {
    // @ts-ignore

    if (page.language.language_id && languages.length > 0) {
      const updatedLocale = languages.filter(
        (x) => x.language?.id === page.language?.language_id
      )[0]?.language.shortname;
      locale = updatedLocale;
    }
  }

  return "/" + locale + "/" + (page.url !== undefined ? page.url : "");
}

type LogErrorProps = {
  name: string | any;
  message: string | any;
  stack: string | any;
  componentStack: string | any;
  href: string | any;
};
var logStack: any = [];
var logStackTimeout: any;
export function logErrorToBackend(data: LogErrorProps) {
  logStack.push(data);
  if (logStackTimeout) {
    clearTimeout(logStackTimeout);
  }
  logStackTimeout = setTimeout(() => {
    logErrorStackToBackend();
  }, 3000);
}
function logErrorStackToBackend() {
  if (logStack.length) {
    const data: any = {
      logStack: logStack,
    };
    logStack = [];
    // @ts-ignore
    window.axios
      .post("logError", data)
      .then((res: any) => {})
      .catch((error: any) => {
        console.log(error);
      });
  }
}

export const getUpdatedComponents = (
  initialStructure: { components: { [key: string]: any } },
  currentStructure: { components: { [key: string]: any } }
) => {
  const updated: { [key: string]: any }[] = [];

  // Get valid component IDs from the initial structure (server state)
  const serverComponentIds = new Set(
    Object.keys(initialStructure.components).map((id) => parseInt(id))
  );

  // Get valid component IDs from current structure (including new ones being added)
  const currentComponentIds = new Set(
    Object.keys(currentStructure.components)
      .map((id) => parseInt(id))
      .filter((id) => id !== -11) // Exclude editor
  );

  Object.keys(currentStructure.components).forEach((key) => {
    const component = currentStructure.components[key];
    const initialComponent = initialStructure.components[key];

    // Skip editor component (id: -11) - it's frontend-only and should never be sent to backend
    if (component.id === -11 || component.type === "editor") {
      return;
    }

    // Component exists locally but not in initial structure.
    // This happens when a component was added during this session via addComponent
    // (already saved to server). Include it so any attribute changes since creation
    // are also persisted on the next save.
    if (!initialComponent && component.id > 0) {
      const componentCopy = { ...component };
      if (
        componentCopy.childWebpageComponentRelations &&
        Array.isArray(componentCopy.childWebpageComponentRelations)
      ) {
        componentCopy.childWebpageComponentRelations =
          componentCopy.childWebpageComponentRelations.filter(
            (relation: any) => {
              if (relation.child_id === -11) return false;
              const childExistsOnServer = serverComponentIds.has(
                relation.child_id
              );
              const childExistsLocally = currentComponentIds.has(
                relation.child_id
              );
              if (!childExistsOnServer && !childExistsLocally) return false;
              return true;
            }
          );
      }
      updated.push(componentCopy);
      return;
    }

    if (!isEqual(initialComponent, component)) {
      // Clone the component to avoid mutating the original
      const componentCopy = { ...component };

      // Clean up childWebpageComponentRelations
      if (
        componentCopy.childWebpageComponentRelations &&
        Array.isArray(componentCopy.childWebpageComponentRelations)
      ) {
        componentCopy.childWebpageComponentRelations =
          componentCopy.childWebpageComponentRelations.filter(
            (relation: any) => {
              // Remove editor component references
              if (relation.child_id === -11) {
                console.warn(
                  `Removing editor relation from component ${component.id}`
                );
                return false;
              }

              // Keep the relation if:
              // 1. Child exists on server (serverComponentIds has it), OR
              // 2. Child exists in current structure and will be sent (currentComponentIds has it and it's not stale)
              const childExistsOnServer = serverComponentIds.has(
                relation.child_id
              );
              const childExistsLocally = currentComponentIds.has(
                relation.child_id
              );

              if (!childExistsOnServer && !childExistsLocally) {
                // Child doesn't exist anywhere - remove relation
                console.warn(
                  `Removing relation to non-existent component ${relation.child_id} from component ${component.id}`
                );
                return false;
              }

              return true;
            }
          );
      }

      updated.push(componentCopy);
    }
  });

  return updated;
};

export const getUpdatedWebpageComponents = (
  initialStructure: number[],
  currentStructure: number[]
) => {
  if (!Array.isArray(initialStructure) || !Array.isArray(currentStructure)) {
    console.error("Invalid input to getUpdatedWebpageComponents");
    return [];
  }

  // Check if there is any difference in the initialStructure and currentStructure
  if (!isEqual(initialStructure, currentStructure)) {
    console.log("WebpageComponents changed");
    return [...currentStructure];
  }

  return [];
};
